{
  "header": "Settlement Details",
  "disbursement-flow": "Disbursement Flow",
  "receipt-flow": "Receipt Flow",
  "total-amount": "Total Amount",
  "entries-count": "Total Entries",
  "accounted-entries": "Accounted Entries",
  "accounted-entries-short": "accounted",
  "accounted-count": "accounted: {{count}}",
  "accounted-sum": "Accounted Sum",
  "accounted-percent": "Accounted Percent",
  "accounted-percent-label": "of total",
  "no-data": "No settlement data available",
  "entry": "Entry",
  "description": "Description",
  "amount": "Amount",
  "party": "Party",
  "kind": "Kind",
  "amount-party": "Amount (Party)",
  "percent": "Percent",
  "accounted": "Accounted",
  "rest": "Rest",
  "payers": "Payers",
  "payees": "Payees",
  "no-payers": "No payers",
  "no-payees": "No payees",
  "difference": "Difference",
  "balanced": "Balanced",
  "total": "Total",
  "imbalance-warning": "Payers and payees are not balanced",
  "incomplete-data-warning": "Need at least one accounted payer or one accounted payee to compare",
  "issues": "Issues",
  "no-issues": "No issues",
  "all": "All",
  "override-flag": "Override",
  "pending-references": "Pending References",
  "entry-date": "Entry Date",
  "party-role": "Party Role",
  "entity": "Entity"
}
